import React from 'react';
import { Container, Button } from 'react-bootstrap';

export default function StepFinalMateriasUtu({ reset }) {
  return (
    <Container className="form-container text-center">
      <h2 className="form-title">Gracias por tu interés</h2>
      <p>
        Lamentablemente, en este momento nuestro apoyo está dirigido a quienes deben máximo 4 materias de UTU o 5 de liceo. En caso de que surja alguna opción, nos pondremos en contacto para apoyarte.
      </p>
      <p>Por el momento no podemos ayudarte.</p>
      <Button variant="primary" onClick={reset} className="mt-3 botonfinalreiniciar">
        Reiniciar formulario
      </Button>
    </Container>
  );
}
